import type { ISentenceScore } from "./api/ScoreApi";

// Individual exports
export enum ScoreGrade {
    Good = "good",
    OK = "ok",
    Bad = "bad"
}

export enum SentenceScoreStatus {
    Scored = "scored",
    NoSpeech = "no_speech",
    TargetMismatch = "target_mismatch"
}

export const SentenceScoreNoSpeechMessage = "I didn't hear enough speech. Please try again.";
export const SentenceScoreTargetMismatchMessage = "I couldn't match this recording to the sentence. Please try again with the sentence shown.";

export function scoreColor(scoreGrade: ScoreGrade) {
    if (scoreGrade == ScoreGrade.Good) return "#28A164"
    if (scoreGrade == ScoreGrade.OK) return "#FCCD56"
    return "#F25C5C"
}


export function sentenceScoreAllGood(sentenceScore: ISentenceScore) {
    return sentenceScore.passing_grade == ScoreGrade.Good
}

export function sentenceScoreAllOkAtLeastOk(sentenceScore: ISentenceScore) {
    return sentenceScore.passing_grade == ScoreGrade.OK
}

export function sentenceScoreAnyFailed(sentenceScore: ISentenceScore) {
    return sentenceScore.passing_grade == ScoreGrade.Bad || sentenceScoreAllSilence(sentenceScore)
}

export function sentenceScoreAllSilence(sentenceScore: ISentenceScore) {
    return Array.isArray(sentenceScore.is_silence) && sentenceScore.is_silence.length > 0 && sentenceScore.is_silence.every(x => x);
}

export function sentenceScoreStatus(sentenceScore: ISentenceScore) {
    if (sentenceScore.sentence_score_status) return sentenceScore.sentence_score_status;
    if (sentenceScoreAllSilence(sentenceScore)) return SentenceScoreStatus.NoSpeech;
    return SentenceScoreStatus.Scored;
}

export function sentenceScoreStatusMessage(sentenceScore: ISentenceScore) {
    const status = sentenceScoreStatus(sentenceScore);
    if (status == SentenceScoreStatus.NoSpeech) return SentenceScoreNoSpeechMessage;
    if (status == SentenceScoreStatus.TargetMismatch) return SentenceScoreTargetMismatchMessage;
    return null;
}

export function sentenceScoreNonSilentFailed(sentenceScore: ISentenceScore) {
    return sentenceScoreAnyFailed(sentenceScore) && !sentenceScoreAllSilence(sentenceScore)
}

export function hasAnySpokenSentenceScore(sentenceScoreList: ISentenceScore[]) {
    return sentenceScoreList.some(score => sentenceScoreAllSilence(score) == false)
}


export function hexToRgbaColorString(hex: string, alpha: number): string {
    // Remove the hash at the start if it's there
    hex = hex.replace('#', '');

    // Parse the hex string into RGB values
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Return the RGBA color string
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
